import { Link } from 'react-router-dom';
import '../styles/Footer.scss';
import SocialLinks from './SocialLinks';

const navs = [
	{ name: 'HOME', path: '/' },
	{ name: 'PORTFOLIO', path: '/portfolio' },
	{ name: 'CONTACT ME', path: '/contact-me' },
];

function Footer() {
	return (
		<section className="Footer-container">
			<div className="Footer-wrap">
				<div className="Footer-outer-grid">
					<div className="Footer-inner-grid">
						<span className="Nav-logo">
							<a href="/">JULIANA</a>
						</span>
						<ul className="Footer-lists">
							{navs.map((nav, index) => (
								<li key={index}>
									<Link to={nav.path}>{nav.name}</Link>
								</li>
							))}
						</ul>
					</div>
					<SocialLinks variant={'light'} />
				</div>
			</div>
		</section>
	);
}

export default Footer;
